import React from "react";

export default function Testimonial({ testimonial }) {
  return (
    <div
      style={{
        background: "#fff",
        borderRadius: "16px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        maxWidth: 400,
        margin: "0 auto",
        overflow: "hidden",
        fontFamily: "inherit",
      }}
    >
      <div style={{ padding: "2rem 1.5rem 1.5rem 1.5rem", background: "#fff" }}>
        <div
          style={{
            fontSize: "2.5rem",
            color: "#bcb7b1",
            lineHeight: 1,
            marginBottom: "0.5rem",
            opacity: 0.5,
            height: "2rem",
            display: "flex",
            alignItems: "flex-start",
          }}
        >
          <i className="fa fa-quote-left" aria-hidden="true"></i>
        </div>
        <div
          style={{
            color: "#333",
            fontSize: ".9rem",
            lineHeight: 1.6,
            height: "120px",
            overflowY: "auto",
            display: "flex",
            alignItems: "center",
          }}
        >
          {testimonial.context}
        </div>
      </div>
      <div
        style={{
          background: "#e5e0dc",
          padding: "1rem 1.5rem",
          textAlign: "right",
        }}
      >
        <div style={{ fontWeight: "bold", color: "#222" }}>{testimonial.name}</div>
        <div style={{ color: "#444", fontSize: "0.95rem" }}>{testimonial.role}</div>
      </div>
    </div>
  );
}